import axios from 'axios'
const BASE_URL='https://youtube-v31.p.rapidapi.com';


const options = {
    method: 'GET',
    url: BASE_URL,
    params: {
      maxResults: '50'
    },
    headers: {
      'X-RapidAPI-Key': '75bb6b520amsh2270968b81e0478p1d7d02jsn09ce936e5c63',
      'X-RapidAPI-Host': 'youtube-v31.p.rapidapi.com'
    }
  };

  export const fetchFromAPI=async (url)=>{
    const {data}=await axios.get(`${BASE_URL}/${url}`,options)
    return data;
  }